<template>
  <div>
    <H5 v-if="isMobile" :qrcodeUrl="qrcodeUrl" />
    <PC v-else :qrcodeUrl="qrcodeUrl" :channelList="channelList" />
  </div>
</template>

<script lang="ts" setup>
import PC from './pc.vue'
import H5 from './h5.vue'
import { reqGetChannel, type IChannel } from '@/api'
import { ACTIVITY_RANDOM_TYPE } from '~/constants'

const { isMobile } = useDevice()

const route = useRoute()
const source = computed(() => route.query?.pcode || '0')
const channelList = ref<IChannel[]>([])

const qrcodeUrl = ref<string | undefined>('')

const getChannel = () => {
  reqGetChannel(ACTIVITY_RANDOM_TYPE.SHANDONG_5G).then((res) => {
    const data = res.data?.find((v) => v.code === source.value)
    channelList.value = res.data || []
    qrcodeUrl.value = isMobile ? data?.h5_link : data?.pc_link
  })
}

getChannel()

isMobile && setPageLayout('h5')
</script>
